/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import ReactSVG from 'react-svg';
import { css, StyleSheet } from 'aphrodite';

import { HelpAction } from 'blb-components/AuthenticatedApp/HelpAction';
import { UserIconButton } from 'blb-components/AuthenticatedApp/UserIconButton';

export const styles = StyleSheet.create({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export namespace Sidebar {
  export interface Props {}
}

export const Sidebar: React.FC<Sidebar.Props> = ({}) => {
  return (
    <>
      <div className={css(styles.iconContainer)}>
        <ReactSVG path="./assets/blend-logo-white.svg" />
      </div>
      <div>
        <UserIconButton />
        <HelpAction />
      </div>
    </>
  );
};
